export const currencies = [
    'GBP',
    'EUR',
    'USD',
    'NZD',
    'AUD',
    'CAD',
    'ZAR',
] as const

export type AppCurrency = (typeof currencies)[number]
